export class LicensingCountry {
  public countryId: number;
  public countryName: string;
  public region: string;
}
